<script>
import MyMarkBlock from 'Vue/Web/Common/MyMarkBlock.vue';

import EventBus from 'FF/Core/EventBus';
import 'lazysizes';
import RecommendNoteComponent from 'Vue/Web/Common/RecommendNoteComponent.vue';
import RecommendCourseComponent from 'Vue/Web/Common/RecommendCourseComponent.vue';
import RecommendProductComponent from 'Vue/Web/Common/RecommendProductComponent.vue';
import SectionRatingComponent from 'Vue/Web/Common/Rating/SectionRatingComponent.vue';
import RightSideSalesComponent from 'Vue/Web/Shop/Course/RightSideSalesComponent.vue';

export default {
    components: {
        MyMarkBlock,
        RecommendNoteComponent,
        RecommendCourseComponent,
        RecommendProductComponent,
        SectionRatingComponent,
        RightSideSalesComponent,
    },
    el: '.content',
    data() {
        return {
            Product: Json.Product,
            newHeader: false,
            favoriteAddedData: false,
        };
    },
    created() {
        const mainHeader = document.querySelector('.mainHeader');

        if (mainHeader) {
            this.newHeader = true;
        }
    },
    methods: {
        changeFavoriteAddedData(data) {
            this.favoriteAddedData = data;
        },
    },
    mounted() {
        EventBus.$on('changeFavoriteAddedData', this.changeFavoriteAddedData);
    },
    computed: {
    },
};
</script>
<style scoped lang="scss">
.cart-item {
    display: flex;
    margin-bottom: 1rem;
    height: 50px;

    .cart-form {
        flex: 6;

        .cart-button {
            height: 100%;
            width: 95%;
            background: #72ca4a;
            color: white;
            margin-right: 1rem;
            font-size: 15px;
            transition: 0.3s;
            line-height: 2.5;

            &:hover {
                background: #91d671;
                transition: 0.3s;
            }
        }
    }

    .addcart-form {
        .addcart-btn {
            height: 50px;
            width: 50px;
            border: solid 2px #72ca4a;
            background: url(../img/pic/addcart_btn.png);
            background-size: contain;

            &:hover {
                ransition: 0.3s;
                background: url(../img/pic/addcart_btn_white.png);
                background-size: contain;
            }
        }
    }
}
</style>
